import SpeciesTraitPane from "./SpeciesTraitPane";

export default SpeciesTraitPane;
export { SpeciesTraitPane };
